import axios from '../../../axios';
import IPaginationSettings from '../types/IPaginationSettings';
export const getPaginationSettings = () =>
  axios.get('recruitersearch/api/recruiters/get-pagination-settings');
export const savePaginationSettings = (payload: IPaginationSettings) =>
  axios.post('recruitersearch/api/recruiters/save-pagination-settings', payload);
